import React from 'react';

// const PricingStructure = () => {
//   return (
//     <section className="bg-white py-10 px-4 md:px-10 rounded-2xl shadow-md max-w-4xl mx-auto">
//       <h2 className="text-3xl font-bold text-center mb-6 text-gray-800">Transparent Pricing</h2>
//       <div className="space-y-4 text-gray-700 text-lg">
//         <p><strong>Trip Fee:</strong> from $85</p>
//         <p><strong>Labor:</strong> Flat rate or hourly — your choice</p>
//         <p><strong>Parts:</strong> Always pre-approved, with proof</p>
//         <p><strong>Emergency Rates:</strong> Available on request</p>
//       </div>
//       <div className="mt-6 text-center">
//         <p className="text-white bg-blue-600 hover:bg-blue-700 px-6 py-2 text-lg rounded-xl">
//           Download Full Pricing Sheet
//         </p>
//       </div>
//     </section>
//   );
// };

// export default PricingStructure;

const PricingStructure = () => {
    return (
        <section className="relative max-w-screen-xl mx-auto py-4 px-4 md:px-8">
            <div className="absolute top-0 left-0 w-full h-full bg-white opacity-40"></div>
            <div className="relative z-10 gap-5 items-center lg:flex">
                <div className="flex-1 max-w-lg py-5 sm:mx-auto sm:text-center lg:max-w-max lg:text-left">
                    <h3 className="text-3xl text-gray-800 font-semibold md:text-4xl">
                        Transparent Pricing <span className="text-indigo-600">No hidden costs</span>
                    </h3>
                    
                          <div className="space-y-2 text-gray-700 text-md mt-4">
        <p>Service call: Depends of the State/City</p>
        <p>Labor: Flat rate or hourly — your choice</p>
        <p>Parts: Always pre-approved, with proof</p>
        <p>Emergency Rates: Available on request</p>
      </div>

                    <a
                        className="mt-5 px-4 py-2 text-indigo-600 font-medium bg-indigo-50 rounded-full inline-flex items-center"
                        href="#leadform">
                        Request full prices
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 ml-1 duration-150" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                    </a>
                </div>
                <div className="flex-1 mt-5 mx-auto sm:w-9/12 lg:mt-0 lg:w-auto">
                    <img 
                        src="https://i.postimg.cc/kgd4WhyS/container.png" 
                        alt="Home Services Houston Texas" 
                        className="w-full" 
                    />
                </div>
            </div>
        </section>
    )
}

export default PricingStructure;
